import createEnum from 'scripts/lib/create_enum';

export default createEnum('BROWSER', 'DIRECT_DIAL', 'NONE', 'STATION');



// WEBPACK FOOTER //
// ./src/scripts/domain/models/agent_phone_preferences.js